import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconUpload = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 14 14"
    >
      <g transform="translate(0, 0.5)">
        <path
          d="M12.5 7.35C12.3276 7.35 12.1623 7.41848 12.0404 7.54038C11.9185 7.66228 11.85 7.82761 11.85 8V11.35H2.15V8C2.15 7.82761 2.08152 7.66228 1.95962 7.54038C1.83772 7.41848 1.67239 7.35 1.5 7.35C1.32761 7.35 1.16228 7.41848 1.04038 7.54038C0.918482 7.66228 0.85 7.82761 0.85 8V11.5C0.85 11.805 0.97116 12.0975 1.18683 12.3132C1.40249 12.5288 1.695 12.65 2 12.65H12C12.305 12.65 12.5975 12.5288 12.8132 12.3132C13.0289 12.0975 13.15 11.805 13.15 11.5V8C13.15 7.82761 13.0815 7.66228 12.9596 7.54038C12.8377 7.41848 12.6724 7.35 12.5 7.35Z"
          fill="white"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M10.0899 3.16521L10.0899 3.16519L10.0876 3.16292L7.46264 0.537915L7.46265 0.537901L7.46084 0.536148C7.3373 0.416691 7.17217 0.349914 7.00032 0.349914C6.82847 0.349914 6.66335 0.416691 6.5398 0.536148L6.53979 0.536132L6.53801 0.537915L3.913 3.16292L3.91298 3.1629L3.91076 3.16521C3.82292 3.25689 3.76327 3.37188 3.73892 3.4965C3.71457 3.62112 3.72654 3.7501 3.77341 3.86811L3.77376 3.86899C3.82223 3.98881 3.90532 4.09146 4.01242 4.16382C4.11952 4.23618 4.24576 4.27497 4.37501 4.27524L4.37532 4.27524L6.35032 4.27524L6.35032 8.00024C6.35032 8.17263 6.4188 8.33796 6.5407 8.45986C6.6626 8.58176 6.82793 8.65024 7.00032 8.65024C7.17271 8.65024 7.33804 8.58176 7.45994 8.45986C7.58184 8.33796 7.65032 8.17263 7.65032 8.00024L7.65032 4.27524L9.62533 4.27524L9.62563 4.27524C9.75488 4.27497 9.88112 4.23618 9.98822 4.16382C10.0953 4.09146 10.1784 3.98881 10.2269 3.86899L10.2269 3.86899L10.2272 3.86811C10.2741 3.7501 10.2861 3.62112 10.2617 3.4965C10.2374 3.37188 10.1777 3.25689 10.0899 3.16521Z"
          fill="white"
          stroke="white"
          strokeWidth="0.3"
        />
      </g>
    </SvgIcon>
  ))
);
